export default __webpack_public_path__ + "static/media/IMG_2500.fe2acfa8.JPG";